import D1 from '../../components/ExcerciseTypes/Design/TypeIn';


const json = {
  1: { // Exercise num
    unit: 'Review 1',
    id: 'SB4-PV-P26-E1',
    audio: '',
    video: '',
    component: D1,
    padding: 0,
    maxLength: 1,
    exerciseKey: 'img/FriendsPlus/Page26/E1/Key/answerKey.png',
    textAlign: 'center',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page26/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page26/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page26/E1/3.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page26/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page26/E1/5.jpg', input: true, answer: "h" },
        { url: 'img/FriendsPlus/Page26/E1/6.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page26/E1/7.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page26/E1/8.jpg', input: true, answer: "g" },
        { url: 'img/FriendsPlus/Page26/E1/9.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page26/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page26/E1/11.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page26/E1/12.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page26/E1/13.jpg' },
        { url: 'img/FriendsPlus/Page26/E1/14.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page26/E1/15.jpg', input: true, answer: "m" },
        { url: 'img/FriendsPlus/Page26/E1/16.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page26/E1/17.jpg', input: true, answer: "r" },
        { url: 'img/FriendsPlus/Page26/E1/18.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page26/E1/19.jpg' },
        { url: 'img/FriendsPlus/Page26/E1/20.jpg', input: true, answer: "o" },
        { url: 'img/FriendsPlus/Page26/E1/21.jpg' },
        { url: 'img/FriendsPlus/Page26/E1/22.jpg', input: true, answer: "l" },
        { url: 'img/FriendsPlus/Page26/E1/23.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page26/E1/24.jpg' },
        { url: 'img/FriendsPlus/Page26/E1/25.jpg', input: true, answer: "p" },
        { url: 'img/FriendsPlus/Page26/E1/26.jpg' },
        { url: 'img/FriendsPlus/Page26/E1/27.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page26/E1/28.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page26/E1/29.jpg', input: true, answer: "g" },
        { url: 'img/FriendsPlus/Page26/E1/30.jpg' },
        { url: 'img/FriendsPlus/Page26/E1/31.jpg', input: true, answer: "o" },
        { url: 'img/FriendsPlus/Page26/E1/32.jpg' },
        { url: 'img/FriendsPlus/Page26/E1/33.jpg', input: true, answer: "l" },
        { url: 'img/FriendsPlus/Page26/E1/34.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page26/E1/35.jpg' },
        { url: 'img/FriendsPlus/Page26/E1/36.jpg', input: true, answer: "k" },
        { url: 'img/FriendsPlus/Page26/E1/37.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page26/E1/38.jpg' },
        { url: 'img/FriendsPlus/Page26/E1/39.jpg', input: true, answer: "h" },
        { url: 'img/FriendsPlus/Page26/E1/40.jpg', input: true, answer: "o" },
        { url: 'img/FriendsPlus/Page26/E1/41.jpg', input: true, answer: "p" },
        { url: 'img/FriendsPlus/Page26/E1/42.jpg', input: true, answer: "p" },
        { url: 'img/FriendsPlus/Page26/E1/43.jpg' },
        { url: 'img/FriendsPlus/Page26/E1/44.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page26/E1/45.jpg', input: true, answer: "g" },
        { url: 'img/FriendsPlus/Page26/E1/46.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page26/E1/47.jpg' },
        { url: 'img/FriendsPlus/Page26/E1/48.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page26/E1/49.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page26/E1/50.jpg' },
        { url: 'img/FriendsPlus/Page26/E1/51.jpg', input: true, answer: "g" },
        { url: 'img/FriendsPlus/Page26/E1/52.jpg' },
      ],
      [
        // Column11
        { url: 'img/FriendsPlus/Page26/E1/53.jpg' },
      ],



    ],
  },
  2: { // Exercise num
    unit: 'Review 1',
    id: 'SB4-PV-P26-E2',
    audio: '',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page26/E2/Key/answerKey.png',
    component: D1,
    padding: 0,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page26/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page26/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page26/E2/3.jpg', input: true, answer: "season" },
        { url: 'img/FriendsPlus/Page26/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page26/E2/5.jpg', input: true, answer: "playing" },
        { url: 'img/FriendsPlus/Page26/E2/6.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page26/E2/7.jpg' },
        { url: 'img/FriendsPlus/Page26/E2/8.jpg', input: true, answer: "fishing" },
        { url: 'img/FriendsPlus/Page26/E2/9.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page26/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page26/E2/11.jpg', input: true, answer: "taking" },
        { url: 'img/FriendsPlus/Page26/E2/12.jpg' },
        { url: 'img/FriendsPlus/Page26/E2/13.jpg', input: true, answer: "camera" },
        { url: 'img/FriendsPlus/Page26/E2/14.jpg' },
      ],


    ],
  },
  3: { // Exercise num
    unit: 'Review 1',
    id: 'SB4-PV-P26-E3',
    audio: '',
    video: '',
    component: D1,
    maxLength: 1,
    exerciseKey: 'img/FriendsPlus/Page26/E3/Key/answerKey.png',
    textAlign: 'center',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page26/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page26/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page26/E3/3.jpg', input: true, answer: "T" },
        { url: 'img/FriendsPlus/Page26/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page26/E3/5.jpg' },
        { url: 'img/FriendsPlus/Page26/E3/6.jpg', input: true, answer: "F" },
        { url: 'img/FriendsPlus/Page26/E3/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page26/E3/8.jpg' },
        { url: 'img/FriendsPlus/Page26/E3/9.jpg', input: true, answer: "F" },
        { url: 'img/FriendsPlus/Page26/E3/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page26/E3/11.jpg' },
        { url: 'img/FriendsPlus/Page26/E3/12.jpg', input: true, answer: "T" },
        { url: 'img/FriendsPlus/Page26/E3/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page26/E3/14.jpg' },
        { url: 'img/FriendsPlus/Page26/E3/15.jpg', input: true, answer: "T" },
        { url: 'img/FriendsPlus/Page26/E3/16.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page26/E3/17.jpg' },
      ],



    ],
  },


}

export default json;